<template>
  <section>
    <b-card class="mb-1 sticky-top" style="height: 58px; font-family: NanumBarunGothic; padding: 1.0rem 1.5rem;" no-body>
      <b-row>
        <b-col cols="10">
          <b-row class="d-flex align-items-center justify-content-start">
            <span class="bg-primary round text-white ml-2" style="width: 80px; font-size: 16px; font-weight: 400; margin-right: 5px; text-align: center;">기간</span>
            <b-form-radio
              v-model="conditionData.periodType"
              name="period-radios"
              value="3년"
              class="bi-radio ml-2"
              style="margin-top: 2px;"
            >
              3년
            </b-form-radio>
            <b-form-radio
              v-model="conditionData.periodType"
              name="period-radios"
              value="5년"
              class="bi-radio ml-5"
              style="margin-top: 2px;"
            >
              5년
            </b-form-radio>
            <b-form-radio
              v-model="conditionData.periodType"
              name="period-radios"
              value="7년"
              class="bi-radio ml-5 mr-5"
              style="margin-top: 2px;"
            >
              7년
            </b-form-radio>
            <span class="bg-primary round text-white ml-5" style="width: 80px; font-size: 16px; font-weight: 400; margin-right: 5px; text-align: center;">조건</span>
            <vue-select
              class="major-class"
              label="title"            
              :options="majorClassList"
              :clearable="true"
              v-model="selectedMajorClass"
              placeholder="대분류(전체)"
              style="height: 32px; width: 180px; text-align: center; font-size: 12px; font-weight: 600; margin-left: 5px;"
              @input="majorChange"
            >
            </vue-select>
            <vue-select
              class="middle-class mr-5"
              label="title"            
              :options="middleClassList"
              :clearable="true"
              v-model="selectedMiddleClass"
              placeholder="중분류(전체)"
              style="height: 32px; width: 180px; text-align: center; font-size: 12px; font-weight: 600; margin-left: 5px;"
              @input="middleChange"
            >
              <template v-slot:no-options >
                <em style="opacity: 0.5; font-size: 12px;">대분류 항목을 선택하세요.</em>
              </template>
            </vue-select>
            <v-divider
              thickness="10"
              class="border-opacity-100"
              style="border-width: 1.2px; margin-top: 3px; margin-bottom: 1px; border-color: #d8d6de;"
              vertical
            />
            <b-form-radio
              v-model="conditionData.dateType"
              name="condition-radios"
              value="month"
              class="bi-radio ml-5"
              style="margin-top: 2px;"
            >
              월별
            </b-form-radio>
            <b-form-radio
              v-model="conditionData.dateType"
              name="condition-radios"
              value="year"
              class="bi-radio ml-2 mr-5"
              style="margin-top: 2px;"
            >
              연별
            </b-form-radio>
            <v-divider
              thickness="10"
              class="border-opacity-100"
              style="border-width: 1.2px; margin-top: 3px; margin-bottom: 1px; border-color: #d8d6de;"
              vertical
            />
            <b-button class="ml-5" id="analysis" style="height: 28px; width: 80px; padding: 0.5rem 0.85rem; margin-left: 5px;" @click="runAnalysis">
              분석하기
            </b-button>
          </b-row>                   
        </b-col>
        <b-col cols="2">
          <b-row class="d-flex align-items-center justify-content-end">
            <b-button id="exp_pdf" style="height: auto; width: 40px; padding: 0.6rem 0.85rem; margin-right: 5px;" @click="exportToPDF">
              <div v-if="isPdfExporting" class="spinner-border spinner-border-sm"></div>
              <div v-else>
                <i class="fa-regular fa-file-pdf fa-lg"/>
              </div>
            </b-button>
            <b-tooltip target="exp_pdf" triggers="hover"> Export to PDF </b-tooltip>
            <b-button id="exp_xls" style="height: auto; width: 40px; padding: 0.6rem 0.85rem; margin-right: 5px;" @click="exportToExcel">
              <div v-if="isXlsExporting" class="spinner-border spinner-border-sm"></div>
              <div v-else>
                <i class="fa-regular fa-file-excel fa-lg"/>
              </div>
            </b-button>    
            <b-tooltip target="exp_xls" triggers="hover"> Export to Excel </b-tooltip>
          </b-row>
        </b-col>
      </b-row>
    </b-card>

    <b-card ref="brdPrintArea1" class="brandindex mb-1" style="font-family: NanumBarunGothic; padding: 1.0rem 1.5rem;" no-body>
      <b-row>
        <b-col cols="12">
          <b-card-text>
            <h3 class="ml-1 mb-1">TOTAL</h3>
            <h6 class="text-primary" style="margin-left: 10px; margin-top: 10px; margin-bottom: -2px;"> 
              카테고리 내 전체 검색량
            </h6>
            <small style="padding-left: 12px;">👉 카테고리에 대한 소비자의 관심 수준을 바탕으로 시장의 변화를 보여줍니다.</small>
          </b-card-text>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" style="position: relative;">
          <div id="loadingLine_total" class="text-center text-primary my-2" style="position: absolute; top: 40%; left: 45%; visibility: visible;">
            <b-spinner class="align-middle mr-2"></b-spinner>
            <strong>분석중...</strong>
          </div>
          <div id="lineChart_total" style="visibility: hidden;">
             <brandindex-line-chart
              :brandindexLineChart="totChartSeries"
              :chartCategories="totChartCategories"
              :chartYaxisTitle="tot_yaxis_title"
              :isChartInit="totLnChartInit"
              :updateHighlight="totHighlightSeries"
              chartID="totLnChart"
            />
          </div>
          <div v-if="this.totLnChartInit" style="border-width: 2px; border-color: #b4bec8; border-style: solid; border-radius: 5px; background-color: aliceblue; margin: 5px; margin-top: -15px;">          
            <div style="text-align: left; color: #5e5873; font-size: 13px; margin: 5px;">
              <div style="margin-bottom: 4px;">
                • 최근 <b>{{ this.conditionData.periodType }}</b> 중 최고검색량은 <b>{{ this.totHiSearchVolDt }} - {{ this.totHiSearchVol.toLocaleString() }}건</b> 이었으며, 최저검색량은 <b>{{ this.totLoSearchVolDt }} - {{ this.totLoSearchVol.toLocaleString() }}건</b> 이었습니다.
              </div>
              <div v-if="this.totHiSeason == 0 && this.totLoSeason == 0" style="margin-bottom: 4px;">
                • 최근 <b>{{ this.conditionData.periodType }}</b> 동안 연중 최고/최저검색량은 매년 다른 월에 발생하였습니다.
              </div>
              <div v-else-if="this.totHiSeason > 0 && this.totLoSeason == 0" style="margin-bottom: 4px;"> 
                • 최근 <b>{{ this.conditionData.periodType }}</b> 동안 연중 최고검색량 발생 빈도수가 높은 월은 <b>{{ this.totHiSeason }}월</b> 이며, 연중 최저검색량은 매년 다른 월에 발생하였습니다. 
              </div>
              <div v-else-if="this.totHiSeason == 0 && this.totLoSeason > 0" style="margin-bottom: 4px;">
                • 최근 <b>{{ this.conditionData.periodType }}</b> 동안 연중 최고검색량은 매년 다른월에 발생하였으며, 연중 최저검색량 발생 빈도수가 높은 월은 <b>{{ this.totLoSeason }}월</b> 입니다. 
              </div>
              <div v-else style="margin-bottom: 4px;">
                • 최근 <b>{{ this.conditionData.periodType }}</b> 동안 연중 최고검색량 발생 빈도수가 높은 월은 <b>{{ this.totHiSeason }}월</b> 이며, 연중 최저검색량 발생 빈도수가 높은 월은 <b>{{ this.totLoSeason }}월</b> 입니다.
              </div>              
            </div>
          </div>
        </b-col>
      </b-row>
    </b-card>    

    <b-card ref="brdPrintArea2" class="brandindex mb-1" style="font-family: NanumBarunGothic; padding: 1.0rem 1.5rem;" no-body>
      <b-row>
        <b-col cols="12">
          <b-card-text>
            <h3 class="ml-1 mb-1">BRANDED & NONBRANDED</h3>
            <h6 class="text-primary" style="margin-left: 10px; margin-top: 10px; margin-bottom: -2px;"> 
              카테고리 내 브랜드가 포함된 검색량(BRANDED)과 그렇지 않은 검색량(NONBRANDED)
            </h6>
            <small style="padding-left: 12px;">👉 카테고리에서 소비자의 브랜드에 대한 관심 수준을 바탕으로 시장의 특징을 보여줍니다.</small>
          </b-card-text>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" style="position: relative;">
          <div id="loadingLine_brand" class="text-center text-primary my-2" style="position: absolute; top: 40%; left: 45%; visibility: visible;">
            <b-spinner class="align-middle mr-2"></b-spinner>
            <strong>분석중...</strong>
          </div>
          <div id="lineChart_brand" style="visibility: hidden;">
            <brandindex-line-chart
              :brandindexLineChart="brnChartSeries"
              :chartCategories="brnChartCategories"
              :chartYaxisTitle="brn_yaxis_title"
              :isChartInit="brnLnChartInit"
              :updateHighlight="brnHighlightSeries"
              chartID="brnLnChart"
            />
          </div>
          <div v-if="this.brnLnChartInit" style="border-width: 2px; border-color: #b4bec8; border-style: solid; border-radius: 5px; background-color: aliceblue; margin: 5px; margin-top: -15px;">          
            <div style="text-align: left; color: #5e5873; font-size: 13px; margin: 5px;">
              <div style="margin-bottom: 4px;">
                • 최근 <b>{{ this.conditionData.periodType }}</b> 중 <b>NONBRANDED</b> 최고검색량은 <b>{{ this.nbrHiSearchVolDt }} - {{ this.nbrHiSearchVol.toLocaleString() }}건</b> 이었으며, <b>BRANDED</b> 최고검색량은 <b>{{ this.brnHiSearchVolDt }} - {{ this.brnHiSearchVol.toLocaleString() }}</b>건 이었습니다.
              </div>
              <div v-if="this.nbrHiSeason == 0 && this.nbrLoSeason == 0" style="margin-bottom: 4px;">
                • <b>NONBRANDED</b>의 연중 최고/최저검색량은 매년 다른 월에 발생하였습니다.
              </div>
              <div v-else-if="this.nbrHiSeason > 0 && this.nbrLoSeason == 0" style="margin-bottom: 4px;"> 
                • <b>NONBRANDED</b>의 연중 최고검색량 발생 빈도수가 높은 월은 <b>{{ this.nbrHiSeason }}월</b> 이며, 연중 최저검색량은 매년 다른 월에 발생하였습니다. 
              </div>
              <div v-else-if="this.nbrHiSeason == 0 && this.nbrLoSeason > 0" style="margin-bottom: 4px;">
                • <b>NONBRANDED</b>의 연중 최고검색량은 매년 다른월에 발생하였으며, 연중 최저검색량 발생 빈도수가 높은 월은 <b>{{ this.nbrLoSeason }}월</b> 입니다. 
              </div>
              <div v-else style="margin-bottom: 4px;">
                • <b>NONBRANDED</b>의 연중 최고검색량 발생 빈도수가 높은 월은 <b>{{ this.nbrHiSeason }}월</b> 이며, 연중 최저검색량 발생 빈도수가 높은 월은 <b>{{ this.nbrLoSeason }}월</b> 입니다.
              </div> 
              <div v-if="this.brnHiSeason == 0 && this.brnLoSeason == 0" style="margin-bottom: 4px;">
                • <b>BRANDED</b>의 연중 최고/최저검색량은 매년 다른 월에 발생하였습니다.
              </div>
              <div v-else-if="this.brnHiSeason > 0 && this.brnLoSeason == 0" style="margin-bottom: 4px;"> 
                • <b>BRANDED</b>의 연중 최고검색량 발생 빈도수가 높은 월은 <b>{{ this.brnHiSeason }}월</b> 이며, 연중 최저검색량은 매년 다른 월에 발생하였습니다. 
              </div>
              <div v-else-if="this.brnHiSeason == 0 && this.brnLoSeason > 0" style="margin-bottom: 4px;">
                • <b>BRANDED</b>의 연중 최고검색량은 매년 다른월에 발생하였으며, 연중 최저검색량 발생 빈도수가 높은 월은 <b>{{ this.brnLoSeason }}월</b> 입니다. 
              </div>
              <div v-else style="margin-bottom: 4px;">
                • <b>BRANDED</b>의 연중 최고검색량 발생 빈도수가 높은 월은 <b>{{ this.brnHiSeason }}월</b> 이며, 연중 최저 검색량 발생 빈도수가 높은 월은 <b>{{ this.brnLoSeason }}월</b> 입니다.
              </div>              
            </div>
          </div>
        </b-col>
      </b-row>
    </b-card>  

    <b-card ref="brdPrintArea3" class="brandindex mb-1" style="font-family: NanumBarunGothic; padding: 1.0rem 1.5rem;" no-body>
      <b-row>
        <b-col cols="12">
          <b-card-text>
            <h3 class="ml-1 mb-1">COMPETITION</h3>
            <h6 class="text-primary" style="margin-left: 10px; margin-top: 10px; margin-bottom: -2px;"> 
              해당 카테고리에서 각 브랜드가 차지하는 검색량
            </h6>
            <small style="padding-left: 12px;">👉 각 브랜드의 퍼포먼스를 평가합니다.</small>
          </b-card-text>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" style="position: relative;">
          <div id="loadingLine_comp" class="text-center text-primary my-2" style="position: absolute; top: 40%; left: 45%; visibility: visible;">
            <b-spinner class="align-middle mr-2"></b-spinner>
            <strong>분석중...</strong>
          </div>
          <div id="lineChart_comp" style="visibility: hidden;">
            <brandindex-line-chart
              :brandindexLineChart="comChartSeries"
              :chartCategories="comChartCategories"
              :chartYaxisTitle="com_yaxis_title"
              :isChartInit="comLnChartInit"
              :updateHighlight="comHighlightSeries"
              chartID="comLnChart"
            />
          </div>
          <div v-if="this.comLnChartInit" style="border-width: 2px; border-color: #b4bec8; border-style: solid; border-radius: 5px; background-color: aliceblue; margin: 5px; margin-top: -15px;">          
            <div style="text-align: left; color: #5e5873; font-size: 13px; margin: 5px;">
              <div v-if="this.comChartData.length == 1" style="margin-bottom: 4px;">
                • 최근 <b>{{ this.conditionData.periodType }}</b> 중 가장 많이 검색된 브랜드는 🥇<b>{{ this.comChartData[0].brand }}</b> 입니다.
              </div>  
              <div v-else-if="this.comChartData.length == 2" style="margin-bottom: 4px;">
                • 최근 <b>{{ this.conditionData.periodType }}</b> 중 가장 많이 검색된 브랜드는 🥇<b>{{ this.comChartData[0].brand }}</b> 였으며, 그 뒤를 🥈<b>{{ this.comChartData[1].brand }}</b>이 쫓고 있습니다.
              </div>            
              <div v-else style="margin-bottom: 4px;">
                • 최근 <b>{{ this.conditionData.periodType }}</b> 중 가장 많이 검색된 브랜드는 🥇<b>{{ this.comChartData[0].brand }}</b> 였으며, 그 뒤를 🥈<b>{{ this.comChartData[1].brand }}</b>, 🥉<b>{{ this.comChartData[2].brand }}</b>이 쫓고 있습니다.
              </div>  
              <div style="color: #1951dc; margin-left: 5px;">
                👉 다른 분석 메뉴를 이용하여, 자세한 내용을 확인해보세요.
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </section>
</template>

<script>
import { 
  BCard,
  BCardText,
  BCol, 
  BRow, 
  BCardBody, 
  BFormRadio, 
  BTable,
  BSpinner,
  BPagination,
  BFormGroup,
  BFormSelect,
  BButton,
  BTooltip,
  BImg,
  BIcon,
  BIconExclamationCircleFill,
} from "bootstrap-vue";

import vSelect from "vue-select";

import moment from "moment";

import ToastificationContent from "@core/components/toastification/ToastificationContent";

import BrandindexLineChart from "@/views/cis-brandindex/components/BrandIndexLineChart.vue";

import BrandIndexService from "@/services/cis-brandindex.service";
import CategoryService from "@/services/category.service";

import ExportPDF from "@/components/pdfExport";
import debounce from "lodash";

import * as XLSX from 'xlsx';

import axios from "axios"

const stringStyle = { font: { name: 'Consolas' } };
const indexNumStyle = { font: { name: 'Consolas' }, numFmt: "0" };
const intNumStyle = { font: { name: 'Consolas' }, numFmt: "#,##0" };
const intNumColorStyle = { font: { name: 'Consolas' }, numFmt: "[Blue]\\ \\▲#,##0;[Red]\\ \\▼#,##0;[Black]\\ \"-\"" };
const floatNumStyle = { font: { name: 'Consolas' }, numFmt: "#,##0.0" };
const rateNumStyle = { font: { name: 'Consolas' }, numFmt: "#,##0.0%" };
const rateNumColorStyle = { font: { name: 'Consolas' }, numFmt: "[Blue]\\ \\▲#,##0%;[Red]\\ \\▼#,##0%;[Black]\\ \"-\"" };

const boldStyle = { font: { name: 'Consolas', bold: true } };
const underlineStyle = { font: { name: 'Consolas', underline: true} };

const sleep = delay => new Promise(resolve => setTimeout(resolve, delay));

const cancelToken = axios.CancelToken;
var source = cancelToken.source();

var sel_category = '9999';

export default {
  name: "BrandIndex",
  components: {
      vSelect,

      BCard,
      BCardText,
      BCol,
      BRow,
      BCardBody,
      BFormRadio,
      BTable,
      BSpinner,
      BPagination,
      BFormGroup,
      BFormSelect,
      BButton,
      BTooltip,
      BImg,
      BIcon,
      BIconExclamationCircleFill,

      BrandindexLineChart,
  },
  data() {
    return {
      isPdfExporting: false,
      isXlsExporting: false,

      totLnChartInit: false,
      brnLnChartInit: false,
      comLnChartInit: false,

      tot_yaxis_title: "Total Search Volumn",
      totChartCategories: [],
      totChartData: [],
      totHighlightSeries: "",
      totHiSearchVol: 0,
      totHiSearchVolDt: 0,
      totLoSearchVol: 0,
      totLoSearchVolDt: 0,
      totHiSeason: 0,
      totLoSeason: 0,

      brn_yaxis_title: "Branded & NonBranded Search Volumn",
      brnChartCategories: [],
      brnChartData: [],
      brnHighlightSeries: "",
      brnHiSearchVol: 0,
      brnHiSearchVolDt: 0,
      brnLoSearchVol: 0,
      brnLoSearchVolDt: 0,
      brnHiSeason: 0,
      brnLoSeason: 0,
      nbrHiSearchVol: 0,
      nbrHiSearchVolDt: 0,
      nbrLoSearchVol: 0,
      nbrLoSearchVolDt: 0,
      nbrHiSeason: 0,
      nbrLoSeason: 0,

      com_yaxis_title: "Competition Search Volumn",
      comChartCategories: [],
      comChartData: [],
      comHighlightSeries: "",

      conditionData: {
        dateType: "month",
        periodType: "5년"
      },

      form: {
        monthSelect: []
      },

      searchDate: "",

      totIsBusy: false,
      brnIsBusy: false,
      comIsBusy: false,

      curMonthIdx: 0,
      curYearIdx: 0,

      localeFloatOpt: { minimumFractionDigits: 1, maximumFractionDigits: 1 },

      majorClassList: [],
      middleClassList: [],
      selectedMajorClass: null,
      selectedMiddleClass: null,
    };
  },
  computed: {
    check_selectedCategory(){
      console.log('---------- computed // check_selectedCategory ----------')
      console.log(' sel category : ' + this.$store.getters.getSelectedCategory)

      return this.$store.getters.getSelectedCategory;
    },

    totChartSeries() {
      return this.totChartData.map(item => ({
        name: item.brand,
        data: item.data,
        hidden: item.hidden,
        label_dsp: item.label_dsp,
        markers: item.markers
      }));
    },

    brnChartSeries() {
      return this.brnChartData.map(item => ({
        name: item.brand,
        data: item.data,
        hidden: item.hidden,
        label_dsp: item.label_dsp,
        markers: item.markers
      }));
    },

    comChartSeries() {
      return this.comChartData.map(item => ({
        name: item.brand,
        data: item.data,
        hidden: item.hidden,
        label_dsp: item.label_dsp,
        markers: item.markers
      }));
    }
  },

  watch: {
    check_selectedCategory(val){
      console.log('---------- watch // check_selectedCategory ----------')
      console.log(' sel category : ' + val)
      console.log(' cur category : ' + sel_category)

      if (sel_category != val) {
        this.abort(true, 'change category')

        sel_category = val;

        this.setMajorClasses();
        this.conditionChange();
      }
    }
  },
  methods: {
    getSelectPeriod() {
      var st_dt;
      var en_dt = moment().add(-2, 'days').toDate(); // 데이터 업데이트 시점을 고려

      switch(this.conditionData.periodType) {
        case '3년':
          st_dt = moment().add(-(3 * 12 - 1) , 'month').toDate();
          break;
        case '5년':
          st_dt = moment().add(-(5 * 12 - 1), 'month').toDate();
          break;
        case '7년':
          st_dt = moment().add(-(7 * 12 - 1), 'month').toDate();
          break;
      }

      this.form.monthSelect = [st_dt, en_dt]
    },

    async conditionChange() {
      this.getSelectPeriod();

      var st_dt_str = moment(this.form.monthSelect[0]).format("YYYY-MM")
      var en_dt_str = moment(this.form.monthSelect[1]).format("YYYY-MM")

      this.comAnalysisPeriod = [st_dt_str, en_dt_str]
      this.purAnalysisPeriod = [st_dt_str, en_dt_str]

      this.curMonthIdx = moment(en_dt_str).diff(moment(st_dt_str), 'month');
      this.curYearIdx = moment(en_dt_str.substr(0,4)).diff(moment(st_dt_str.substr(0,4)), 'years');

      await this.loadData(this.conditionData.dateType, st_dt_str, en_dt_str);

      // setTimeout(() => {
      //   var tot_el = document.querySelectorAll("#lineChart_total .apexcharts-legend .apexcharts-legend-series");

      //   if (tot_el != undefined && tot_el.length > 0)
      //     tot_el[1].style.display = "none"

      //   var brn_el = document.querySelectorAll("#lineChart_brand .apexcharts-legend .apexcharts-legend-series");

      //   if (brn_el != undefined && brn_el.length > 0) {
      //     brn_el[2].style.display = "none"
      //     brn_el[3].style.display = "none"
      //   }
      // }, 10)
    },

    majorChange() {
      console.log('---------- major change ----------')

      if (this.selectedMajorClass != null) {
        this.setMiddleClasses();
      }
      else {
        this.middleClassList = [];
        this.selectedMiddleClass = null;
      }
    },

    middleChange() {
      console.log('---------- middle change ----------')
    },

    async loadData(mode, st_dt, en_dt) {
      console.log('---------- loadData ----------')

      if(document.getElementById('loadingLine_total')){
        document.getElementById('loadingLine_total').style.visibility = "visible";
      }
      if(document.getElementById('lineChart_total')){
        document.getElementById('lineChart_total').style.visibility = "hidden";
      }
      if(document.getElementById('loadingLine_brand')){
        document.getElementById('loadingLine_brand').style.visibility = "visible";
      }
      if(document.getElementById('lineChart_brand')){
        document.getElementById('lineChart_brand').style.visibility = "hidden";
      }
      if(document.getElementById('loadingLine_comp')){
        document.getElementById('loadingLine_comp').style.visibility = "visible";
      }
      if(document.getElementById('lineChart_comp')){
        document.getElementById('lineChart_comp').style.visibility = "hidden";
      }

      console.log(' sel category : ' + this.$store.getters.getSelectedCategory)
      console.log(' cur category : ' + sel_category)

      this.totLnChartInit = false;
      this.brnLnChartInit = false;
      this.comLnChartInit = false;

      this.totChartData = [];
      this.brnChartData = [];
      this.comChartData = [];

      this.totChartCategories = [];
      this.brnChartCategories = [];
      this.comChartCategories = [];

      // 카테고리 정보가 설정되지 않은 경우 리턴
      if (sel_category == '9999' && this.$store.getters.getSelectedCategory == '9999') 
        return; 

      sel_category = this.$store.getters.getSelectedCategory;
      
      var sel_Major = this.selectedMajorClass != null ? this.selectedMajorClass.title : null; 
      var sel_Middle = this.selectedMiddleClass != null ? this.selectedMiddleClass : null; 

      if (sel_Middle == '중분류 없음')
        sel_Middle = '기타'

      this.totIsBusy = true;
      this.brnIsBusy = true;

      const catTableResp = await BrandIndexService.getmarketoverview({
        mode: mode, 
        st_dt: st_dt, 
        en_dt: en_dt, 
        ctgSq: sel_category, 
        selMajor: sel_Major, 
        selMiddle: sel_Middle
      }, source);

      console.log('---------- market overview ----------')
      console.log(catTableResp)

      if (catTableResp && catTableResp.status === 200) {
        this.totChartCategories = [];
        this.brnChartCategories = [];
        this.totChartData = [];
        this.brnChartData = [];

        if (catTableResp.data.data[0] != null) {
          var total = catTableResp.data.data[0].total.split(',')
          var branded = catTableResp.data.data[0].branded.split(',')
          var nonbranded = catTableResp.data.data[0].nonbranded.split(',')

          var tot_minmax = this.find_MinMax(catTableResp.data.data[0].date.split(','), total)
          var br_minmax  = this.find_MinMax(catTableResp.data.data[0].date.split(','), branded)
          var nbr_minmax = this.find_MinMax(catTableResp.data.data[0].date.split(','), nonbranded)

          this.totChartData.push({
            brand: 'TOTAL',
            type: 'line',
            data: total,
            label_dsp: tot_minmax.label,
            markers: tot_minmax.marker
          })

          this.brnChartData.push({
            brand: 'NONBRANDED',
            type: 'line',
            data: nonbranded,
            label_dsp: nbr_minmax.label,
            markers: nbr_minmax.marker
          })

          this.brnChartData.push({
            brand: 'BRANDED',
            type: 'line',
            data: branded,
            label_dsp: br_minmax.label,
            markers: br_minmax.marker
          })

          this.totHiSearchVol = tot_minmax.max;
          this.totHiSearchVolDt = moment(tot_minmax.max_dt).format('yyyy년 MM월');
          this.totLoSearchVol = tot_minmax.min;
          this.totLoSearchVolDt = moment(tot_minmax.min_dt).format('yyyy년 MM월');
          this.totHiSeason = tot_minmax.hi_season
          this.totLoSeason = tot_minmax.lo_season

          this.brnHiSearchVol = br_minmax.max;
          this.brnHiSearchVolDt = moment(br_minmax.max_dt).format('yyyy년 MM월');
          this.brnLoSearchVol = br_minmax.min;
          this.brnLoSearchVolDt = moment(br_minmax.min_dt).format('yyyy년 MM월');
          this.brnHiSeason = br_minmax.hi_season
          this.brnLoSeason = br_minmax.lo_season

          this.nbrHiSearchVol = nbr_minmax.max;
          this.nbrHiSearchVolDt = moment(nbr_minmax.max_dt).format('yyyy년 MM월');
          this.nbrLoSearchVol = nbr_minmax.min;
          this.nbrLoSearchVolDt = moment(nbr_minmax.min_dt).format('yyyy년 MM월');
          this.nbrHiSeason = nbr_minmax.hi_season
          this.nbrLoSeason = nbr_minmax.lo_season

          this.totChartCategories = catTableResp.data.data[0].date.split(',')
          this.brnChartCategories = catTableResp.data.data[0].date.split(',')

          this.totLnChartInit = true;
          this.brnLnChartInit = true;
        }

        document.getElementById('loadingLine_total').style.visibility = "hidden";
        document.getElementById('lineChart_total').style.visibility = "visible";
        document.getElementById('loadingLine_brand').style.visibility = "hidden";
        document.getElementById('lineChart_brand').style.visibility = "visible";   
      }

      this.totIsBusy = false;
      this.brnIsBusy = false;

      this.comIsBusy = true;

      const comResp = await BrandIndexService.getallbyperiod({
        mode: mode, 
        index: 'competition', 
        st_dt: st_dt, 
        en_dt: en_dt, 
        ctgSq: sel_category, 
        selMajor: sel_Major, 
        selMiddle: sel_Middle
      }, source);

      console.log('---------- competition ----------')
      console.log(comResp)

      if (comResp && comResp.status === 200) {
        this.comChartData = [];
        this.comChartCategories = [];

        for(const item of comResp.data.data) {    
          const com_data = item.competition.split(',')

          var com_minmax = this.find_MinMax(item.date.split(','), com_data)
          var total_val = 0

          for (const val of com_data)
            total_val += parseFloat(val)
          
          this.comChartData.push({
            brand: item.brand,
            type: 'line',
            data: item.competition.split(','),
            hidden: item.comRank > 5 ? true : total_val > 0 ? false : true,
            label_dsp: com_minmax.label,
            markers: com_minmax.marker
          })

          if (this.comChartCategories.length == 0) {
            this.comChartCategories = item.date.split(',')
          }

          this.comLnChartInit = true;
        }  

        document.getElementById('loadingLine_comp').style.visibility = "hidden";
        document.getElementById('lineChart_comp').style.visibility = "visible";
      }

      this.comIsBusy = false;
    },

    getToday() {
      let date = new Date()
      let year = date.getFullYear()
      let month = date.getMonth() < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)
      let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()

      return year + month + day
    },

    exportToPDF: _.debounce(async function() {
      this.isPdfExporting = true;

      await sleep(1);

      var ret = await ExportPDF.exportToPDF([this.$refs.brdPrintArea1, this.$refs.brdPrintArea2, this.$refs.brdPrintArea3], 'a4', 'l', 'brand_index_' + this.getToday() + '.pdf');

      if (ret) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "PDF export complete!!",
            icon: "EditIcon",
            variant: "success",
          },
        });
      }
      else {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "PDF export fail!!",
            icon: "AlertCircleIcon",
            variant: "warning",
          },
        });
      }

      this.isPdfExporting = false;
    }, 100),

    newSheet4Intro(dataOrigin, category, period, serviceName) {
      var tmp_sheet = []

      tmp_sheet.push([]);
      tmp_sheet.push(['', { v: 'CONSUMER in SEARCH Ai', t: "s", s: boldStyle }]);
      tmp_sheet.push(['', { t: "s", v: "consumerinsearch.com", l: {Target: "https://consumerinsearch.com"}, s: underlineStyle}]);
      tmp_sheet.push([]);
      tmp_sheet.push(['', { v: '데이터 개요', t: "s", s: boldStyle }]);
      tmp_sheet.push(['', { v: '데이터 출처: ', t: "s", s: boldStyle }, { v: dataOrigin, t: "s", s: boldStyle }]);
      tmp_sheet.push(['', { v: '카테고리: ', t: "s", s: boldStyle }, { v: category, t: "s", s: boldStyle }]);
      tmp_sheet.push(['', { v: '분석 기간: ', t: "s", s: boldStyle }, { v: period, t: "s", s: boldStyle }]);
      tmp_sheet.push(['', { v: '서비스명: ', t: "s", s: boldStyle }, { v: serviceName, t: "s", s: boldStyle }]);

      var ws = XLSX.utils.aoa_to_sheet(tmp_sheet)
      ws['!cols'] = this.autoFit(tmp_sheet)

      return ws;
    },

    newSheet4Data(dataOrigin, category, period, columns, data) {
      var tmp_sheet = [];

      // Information
      tmp_sheet.push([{ v: '데이터 출처: ', t: "s", s: boldStyle }, { v: dataOrigin, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '카테고리: ', t: "s", s: boldStyle }, { v: category, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '분석 기간: ', t: "s", s: boldStyle }, { v: period, t: "s", s: boldStyle }]);
      tmp_sheet.push([]);

      // Header
      var header_list = ['No.', '키워드'].concat(columns)
      var tmp_header = [];

      for (const col_nm of header_list)
        tmp_header.push({ v: col_nm, t: "s", s: boldStyle });

      tmp_sheet.push(tmp_header);

      // Data
      for (const idx in data) {
        var tmp_row = [];

        tmp_row.push(Number(idx) + 1);
        tmp_row.push(data[idx].brand);

        for (const sub_item of data[idx].data)
          tmp_row.push({ t: "n", v: Number(sub_item).toFixed(1), s: floatNumStyle });

        tmp_sheet.push(tmp_row)
      }

      var ws = XLSX.utils.aoa_to_sheet(tmp_sheet)
      ws['!cols'] = this.autoFit(tmp_sheet)

      return ws;
    },

    autoFit(data) {
      const wsCols = [];

      data.map((item) => {
        Object.keys(item).map((key, index) => {
          let text = item[key];
          let maxWidth;

          switch(typeof text) {
            case 'number':
              if (wsCols[index]) {
                if (text)
                  maxWidth = wsCols[index].width > 10 ? wsCols[index].width : 10;
                else
                  maxWidth = 10;
              }
              else
                maxWidth = text !== null ? 10 : 0;
                         
              break;
            case 'object':
              if (wsCols[index]) {
                if (text && text['v']) {
                  if (typeof text['v'] === 'number')
                    maxWidth = wsCols[index].width > 10 ? wsCols[index].width : 10;
                  else
                    maxWidth = wsCols[index].width < text['v'].length * 1.5 ? text['v'].length * 1.5 : wsCols[index].width;
                }
                else
                  maxWidth = wsCols[index].width;
              }
              else {
                if (text && text['v']) {
                  if (typeof text['v'] === 'number')
                    maxWidth = text['v'] !== null ? 10 : 0;
                  else
                    maxWidth = text['v'] !== null ? text['v'].length * 1.5 : 0;
                }
                else
                    maxWidth = 0;
              }

              break;
            case 'string':
              if (wsCols[index]) {
                if (text)
                  maxWidth = wsCols[index].width < text.length * 1.5 ? text.length * 1.5 : wsCols[index].width;
                else 
                  maxWidth = wsCols[index].width;
              }
              else 
                maxWidth = text !== null ? text.length * 1.5 : 0;
               
              break;
          }

          wsCols[index] = {width : maxWidth}
        })
      })

      for (var index in wsCols)
        wsCols[index].width = wsCols[index].width === 0 ? 10 : wsCols[index].width * 1.5;

      return wsCols
    },

    exportToExcel: _.debounce(async function() {
      const XLSX = require("xlsx-js-style");

      this.isXlsExporting = true;

      await sleep(1);

      try {
        this.getSelectPeriod();

        var st_dt_str = moment(this.form.monthSelect[0]).format("YYYY-MM")
        var en_dt_str = moment(this.form.monthSelect[1]).format("YYYY-MM")

        const dataOrigin = 'NAVER';
        var category = 'Unknown';

        const response = await CategoryService.getOneCategory(sel_category, source);

        if (response.data.success)
          category = response.data.data.title

        const period = st_dt_str + ' ~ ' + en_dt_str;

        const workbook = XLSX.utils.book_new()	// 엑셀 생성
      
        XLSX.utils.book_append_sheet(workbook, 
                                     this.newSheet4Intro(dataOrigin, category, period, 'MARKET OVERVIEW'),
                                     '데이터 개요')
        XLSX.utils.book_append_sheet(workbook, 
                                     this.newSheet4Data(dataOrigin, category, period, this.totChartCategories, this.totChartData), 
                                     'Total')
        XLSX.utils.book_append_sheet(workbook, 
                                     this.newSheet4Data(dataOrigin, category, period, this.brnChartCategories, this.brnChartData), 
                                     'Branded & NonBranded')
        XLSX.utils.book_append_sheet(workbook, 
                                     this.newSheet4Data(dataOrigin, category, period, this.comChartCategories, this.comChartData), 
                                     'Competition')

        XLSX.writeFile(workbook, 'market_overview_' + this.getToday() + '.xlsx')	// 엑셀 다운로드

        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Excel export complete!!",
            icon: "EditIcon",
            variant: "success",
          },
        });
      }
      catch (err) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Excel export fail!!",
            icon: "AlertCircleIcon",
            variant: "warning",
          },
        });
      }

      this.isXlsExporting = false;
    }, 100),

    abort(isReset, message) {
      console.log('---------- abort ---------- // ' + message)

      // cancel the request
      source.cancel(message);

      if (isReset)
        source = cancelToken.source();
    },

    async setMajorClasses() {
      console.log('---------- setMajorClasses ----------')

      this.majorClassList = [];
      this.selectedMajorClass = null;

      // 카테고리 정보가 설정되지 않은 경우 리턴
      if (sel_category == '9999' && this.$store.getters.getSelectedCategory == '9999') 
        return;

      sel_category = this.$store.getters.getSelectedCategory;

      const majorClasses = await BrandIndexService.getmajorclasslist({ctgSq: this.$store.getters.getSelectedCategory}, source);

      if (majorClasses.data.success) {
        console.log('---------- Major Classes list ----------')
        console.log(majorClasses.data.data)

        this.majorClassList = majorClasses.data.data;        
      }
    },

    async setMiddleClasses() {
      console.log('---------- setMiddleClasses ----------')

      this.middleClassList = [];
      this.selectedMiddleClass = null;

      // 카테고리 정보가 설정되지 않은 경우 리턴
      if (sel_category == '9999' && this.$store.getters.getSelectedCategory == '9999') 
        return;

      sel_category = this.$store.getters.getSelectedCategory;

      this.getSelectPeriod();

      var st_dt_str = moment(this.form.monthSelect[0]).format("YYYY-MM")
      var en_dt_str = moment(this.form.monthSelect[1]).format("YYYY-MM")

      const middleClasses = await BrandIndexService.getmiddleclasslist({
        st_dt: st_dt_str,
        en_dt: en_dt_str,
        ctgSq: this.$store.getters.getSelectedCategory, 
        selMajor: this.selectedMajorClass.title
      }, source);

      if (middleClasses.data.success) {
        console.log('---------- Middle Classes list ----------')
        console.log(middleClasses.data.data)

        this.middleClassList = middleClasses.data.data; 

        var _idx = this.middleClassList.findIndex((element) => element == "기타");

        if (_idx >= 0) {
          this.middleClassList = this.middleClassList.with(_idx, "중분류 없음")
          this.middleClassList.sort()
        }
      }
    },

    runAnalysis() {
      this.conditionChange();
    },

    find_MinMax(date_list, data_list) {
      var years = [];
      var year_div = [];
      var cur_year = 0;

      for (let i = 0; i < date_list.length; i++) {
        var date = moment(date_list[i])

        if (cur_year != date.get('year')) {
          cur_year = date.get('year');

          if (i > 0)
            year_div.push(i);
        }

        if (years.indexOf(date.get('year')) < 0) {
          years.push(date.get('year'));
          year_div.push(i);
        }
      }

      if (year_div.indexOf(date_list.length - 1) < 0) {
        year_div.push(date_list.length - 1);
      }

      var ret_lb = new Array(date_list.length).fill(0);
      var ret_pt = new Array(date_list.length).fill(0);
      var ret_max_val = 0;
      var ret_max_idx = -1;
      var ret_min_val = Number.MAX_SAFE_INTEGER;
      var ret_min_idx = -1;
      var hi_season = new Array(12).fill(0);
      var lo_season = new Array(12).fill(0);

      for (let i = 0; i < year_div.length; i += 2) {
        var min_val = Number.MAX_SAFE_INTEGER;
        var min_val_idx = -1;
        var max_val = 0;
        var max_val_idx = -1;

        for (let j = year_div[i]; j < year_div[i + 1]; j++) {
          if (min_val > Number(data_list[j])) {
            min_val = Number(data_list[j]);
            min_val_idx = j;

            if (ret_min_val > min_val) {
              ret_min_val = min_val;
              ret_min_idx = min_val_idx;
            }
          }

          if (max_val < Number(data_list[j])) {
            max_val = Number(data_list[j]);
            max_val_idx = j;

            if (ret_max_val < max_val) {
              ret_max_val = max_val;
              ret_max_idx = max_val_idx;
            }
          }
        }

        ret_lb[min_val_idx] = 1;
        ret_pt[min_val_idx] = -1;
        ret_lb[max_val_idx] = 1;
        ret_pt[max_val_idx] = 1;

        hi_season[moment(date_list[max_val_idx]).get('Month')] += 1;
        lo_season[moment(date_list[min_val_idx]).get('Month')] += 1;
      }

      const hi_season_max = Math.max(...hi_season);
      const hi_max_count = hi_season.filter(item => item === hi_season_max).length;
      var ret_hi_season = 0;

      const lo_season_max = Math.max(...lo_season);
      const lo_max_count = lo_season.filter(item => item === lo_season_max).length;
      var ret_lo_season = 0;

      if (hi_season_max >= (years.length / 2) && hi_max_count === 1)
        ret_hi_season = hi_season.indexOf(hi_season_max) + 1;
      else
        ret_hi_season = 0;

      if (lo_season_max >= (years.length / 2) && lo_max_count === 1)
        ret_lo_season = lo_season.indexOf(lo_season_max) + 1;
      else
        ret_lo_season = 0;

      return { label: ret_lb, marker: ret_pt, max: ret_max_val, max_dt: date_list[ret_max_idx], min: ret_min_val, min_dt: date_list[ret_min_idx], hi_season: ret_hi_season, lo_season: ret_lo_season };
    },

    handleResize(event) {
    },
  },

  mounted(){
    console.log('---------- mounted ----------')
    console.log(' sel category : ' + this.$store.getters.getSelectedCategory)
    
    setTimeout(() => {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    }, 200);

    // console.log('--> add event : windows resize')
    // window.addEventListener('resize', _.debounce(this.handleResize, 500));
  },

  unmounted() {
    console.log('---------- unmounted ----------')
    // console.log('--> remove event : windows resize')
    // window.removeEventListener('resize', this.handleResize);
  },

  destroyed() {
    console.log('---------- destroyed ----------')
    
    this.abort(false, 'destoryed')
  },

  created() {    
    console.log('---------- create ----------')

    this.abort(true, 'created')

    this.$store.dispatch('callCISMenu', { cisMenu: 'marketoverview' })

    this.getSelectPeriod();
    this.setMajorClasses();
    this.conditionChange();
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.brandindex .card-body {
  padding: 1rem;
  padding-bottom: 0;
  height: 550px;
}

.brandindextable .table-font-size{
  font-size: 12px;
  font-weight: 600;
}

.periodpickr .flat-picker {
   width: auto;
}

.brandindextable .b-table thead th.w10{
  width: 10%;
}

.brandindextable .b-table thead th.w15{
  width: 15%;
}

.brandindextable .b-table thead th.w20{
  width: 20%;
}

.brandindextable .b-table thead th.w25{
  width: 25%;
}

.brandindextable .b-table thead th.w30{
  width: 30%;
}

.brandindextable .b-table thead th.w40{
  width: 40%;
}

.brandindextable .b-table thead th.w50{
  width: 50%;
}

.brandindextable .b-table thead th.w60{
  width: 60%;
}

/* Hide default icon */
.brandindextable .table.b-table > thead > tr > th,
.brandindextable .table.b-table > tfoot > tr > td {
  background-image: none !important;
  vertical-align: middle !important;
  padding: 0.75rem 0.5rem;
}

.bi-radio .custom-control-input:not(:disabled) {
  &:active ~ .custom-control-label {
    &::before {
      background-color: $secondary;
      border-color: $secondary;
    }
  }
}

.bi-radio .custom-control-input:disabled:checked ~ .custom-control-label::before,
.bi-radio .custom-control-input:checked ~ .custom-control-label::before,
.bi-radio .custom-control-input:active ~ .custom-control-label::before,
.bi-radio .custom-control-input:focus ~ .custom-control-label::before
{
  background-color: $secondary;
  border-color: $secondary;
}

.mb-1 .sticky-top {
  align-self: flex-start;
}

.tooltip-inner {
  color: #333;
  background: #fff;
  border: 1px solid #F2F2F2;
  font-family: "NanumBarunGothic", Arial, sans-serif !important;
  filter: none;
  box-shadow: 1px 1px 1px #F2F2F2;
  font-weight: bold;
}

.table-total > th, .table-total > td {
  background-color: #1951dc25;
}

.major-class .vs__dropdown-menu,
.middle-class .vs__dropdown-menu
{
  padding: 0px 0px 0px 0px;
}

.major-class .vs__dropdown-toggle,
.middle-class .vs__dropdown-toggle 
{
  border: 2px solid #d8d6de;
}

.major-class .vs__search,
.middle-class .vs__search,
.major-class .vs__selected,
.middle-class .vs__selected 
{
  height: 20px;
  margin-top: 4px !important;
}
</style>
